import _get from 'lodash/get'
import { FEATURE_NAMES, BENEFIT_NAMES } from 'constants/dataNames'

export const getNormalizedOptionDescription = description => {
  const parts = description.split('|')
  return parts.map(part => {
    if (part === '{True}') {
      return true
    }
    if (part === '{False}') {
      return false
    }
    return part
  })
}

const getValuesByName = (name, allOptionsMap) => {
  return _get(allOptionsMap, [name, 'values'], [])
}

const getOptionsMap = optionsArray => optionsArray.reduce((acc, { key, description }) => ({
  ...acc,
  [key]: {
    name: key,
    values: getNormalizedOptionDescription(description),
  },
}), {})

export const getNormalizedPlan = plan => {
  const benefits = getOptionsMap(plan.features)
  const features = (plan.devices[0] && getOptionsMap(plan.devices[0].deviceFeatures)) || []
  return {
    id: plan.id,
    name: plan.name,
    image: plan.productImageUri,
    productDescription: plan.productDescription,
    price: plan.price,
    weight: plan.weight,
    activationFee: plan.activationFee,
    hasAvailableDevices: plan.hasAvailableDevices,
    visible: typeof plan.visible != 'undefined' ? plan.visible : false,
    benefits: Object.values(BENEFIT_NAMES).reduce((acc, name) => ({
      ...acc,
      [name]: getValuesByName(name, benefits),
    }), {}),
    features: Object.values(FEATURE_NAMES).reduce((acc, name) => ({
      ...acc,
      [name]: getValuesByName(name, features),
    }), {}),
  }
}
